import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from "../../environments/environment";
import {map} from "rxjs/operators";
import {Message} from "../models/message.model";

@Injectable({
  providedIn: 'root'
})
export class MessageApiService {

  private baseUrl:string = environment.apiBaseUrl+"/core/portal/profile/notifications";

  constructor(
    private httpClient: HttpClient
  ) { }

  getMessageList(page, size): Observable<any> {
      return this.httpClient.get<any>(this.baseUrl+`?page=${page}&size=${size}`);
  }

  getMessage(id): Observable<Message> {
    return this.httpClient.get<any>(this.baseUrl+`/${id}`).pipe(map((res) => {
      return res.object
    }));
  }


}

